// src/components/ProtectedRoute.js
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ 
  children,
  requiredPermissions = [], 
  requireAllPermissions = false 
}) => {
  const { user, loading, hasPermission, hasAnyPermission } = useAuth();
  const location = useLocation();

  console.log('[ProtectedRoute - Check Access]', {
    path: location.pathname,
    isAuthenticated: !!user,
    requiredPermissions,
    requireAllPermissions
  });

  if (loading) {
    console.log('[ProtectedRoute - Loading Auth State]');
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500" />
      </div>
    );
  }

  if (!user) {
    console.log('[ProtectedRoute - Unauthorized Access]', {
      redirectTo: '/login',
      from: location.pathname
    });
    
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requiredPermissions.length > 0) {
    const hasAccess = requireAllPermissions
      ? requiredPermissions.every(permission => hasPermission(permission))
      : hasAnyPermission(requiredPermissions);

    console.log('[ProtectedRoute - Permission Check]', {
      hasAccess,
      userRole: user.role,
      requiredPermissions
    });

    if (!hasAccess) {
      console.log('[ProtectedRoute - Permission Denied]');
      return <Navigate to="/unauthorized" replace />;
    }
  }

  console.log('[ProtectedRoute - Access Granted]', {
    user: user.email,
    path: location.pathname
  });

  return children;
};

export default ProtectedRoute;